import { CreateTagDto, DeleteTagDto, IFile, ITag, TagFilterDto } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class FileApi {
  static getFiles() {
    return AdmiralApi.apiCall({
      method: 'PATCH',
      url: `${BASE_URL}/file/list`,
    });
  }

  static getFile(id: string) {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/file/${id}`,
      responseType: 'blob',
    });
  }

  static assignToPolicy(fileId: string, policyId: string) {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/file/assign-to-policy`,
      data: { fileId, policyId },
    });
  }

  static assignToTask(fileId: string, taskId: string) {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/file/assign-to-task`,
      data: { fileId, taskId },
    });
  }

  static assignToDamage(fileId: string, damageId: string) {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/file/assign-to-damage`,
      data: { fileId, damageId },
    });
  }

  static getAgencyStorageUsage() {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/file/usage`,
    });
  }

  static deleteFile(id: string) {
    return AdmiralApi.apiCall({
      method: 'DELETE',
      url: `${BASE_URL}/file/${id}`,
    });
  }

  static uploadFiles(files: File[]) {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));

    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/file/upload`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}
